import styled from "styled-components";

export const ToastWrapper = styled.div`
  position: fixed;
  bottom: 48px;
  left: 24px;
  background-color: ${({ isSuccess }) => (isSuccess ? "#f4fffa" : "#edf6ff")};
  border: ${({ isSuccess }) =>
    isSuccess ? "1px solid #88ffcc" : "1px solid #a6ccfa"};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  max-width: 343px;
  z-index: 10000;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
`;

export const ToastIcon = styled.img`
  width: 100%;
  height: 100%;
  display: block;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

export const ToastTitle = styled.div`
  font-family: SF Pro Text, sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 19.5px;
  color: ${({ isSuccess }) => (isSuccess ? "#057640" : "#0a59ad")};
  letter-spacing: -0.0762px;
`;

export const ToastMessage = styled.div`
  font-family: SF Pro Text, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  color: #333333;
  letter-spacing: -0.0762px;
`;
